import type { VerificationStage } from "../../types.ts";

// Videos sorted before images so the first thumb in TableActions matches the
// first attachment shown in the console.
export const sortAttachments = (
  order: VerificationStage | null | undefined,
) => [...(order?.attachments ?? [])].sort((a, b) => b.type - a.type);
